import { Pipe, PipeTransform } from '@angular/core';
import { AppScope, ResourceTypes } from '@klickdata/core/resource';

@Pipe({
    name: 'typeFontSet',
})
export class TypeFontSetPipe implements PipeTransform {
    transform(type_id: number, scope_id?: AppScope) {
        switch (scope_id || ResourceTypes.scopeByChildType(type_id)) {
            case AppScope.SCORM:
            default:
                return 'klickdata';
        }
    }
}
